import { MagistralDrugTemplate } from '@dreryk/drerykweb-medicine-api';

import { magistralDrugTemplatesTranslationKeys } from '../../../../../translations';

import { MagistralDrugTemplateInsert } from './MagistralDrugReadOnly.types';
import { StyledMagistralDrugTemplateReadOnly } from './MagistralDrugTemplateReadOnly.styled';
import { MagistralDrugTemplateReadOnlyTextView } from './MagistralDrugTemplateReadOnlyTextView';
import { MagistralDrugTemplateRawMaterialsReadOnlyTable } from './rawMaterialsTable/MagistralDrugTemplateRawMaterialsReadOnlyTable';

type MagistralDrugTemplateReadOnlyProps = {
   readonly onInsert?: MagistralDrugTemplateInsert;
   readonly item: MagistralDrugTemplate;
};

export const MagistralDrugTemplateReadOnly = (props: MagistralDrugTemplateReadOnlyProps): JSX.Element | null => {
   const { onInsert, item } = props;
   return (
      <StyledMagistralDrugTemplateReadOnly direction={'column'} gap={'24px'}>
         <MagistralDrugTemplateReadOnlyTextView
            testId={'templateName'}
            label={magistralDrugTemplatesTranslationKeys.templateName}
            onInsertClick={onInsert ? () => onInsert('templateName', props.item.name) : undefined}
         >
            {item.name}
         </MagistralDrugTemplateReadOnlyTextView>
         <MagistralDrugTemplateRawMaterialsReadOnlyTable
            rawMaterials={item.magistralDrugMedicineRawMaterials}
            onInsert={onInsert}
         />
         <MagistralDrugTemplateReadOnlyTextView
            testId={'drugForm'}
            label={magistralDrugTemplatesTranslationKeys.drugForm}
            onInsertClick={onInsert ? () => onInsert('drugForm', item.form) : undefined}
         >
            {item.form!}
         </MagistralDrugTemplateReadOnlyTextView>
         <MagistralDrugTemplateReadOnlyTextView
            testId={'additionalInformation'}
            label={magistralDrugTemplatesTranslationKeys.additionalInformation}
            onInsertClick={onInsert ? () => onInsert('additionalInformation', item.additionalDetails) : undefined}
         >
            {item.additionalDetails}
         </MagistralDrugTemplateReadOnlyTextView>
      </StyledMagistralDrugTemplateReadOnly>
   );
};
